var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastStartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#7af4c5",
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.746 511.721c135.931-6.14 244.254-118.274 244.254-255.721 0-7.761-.365-15.435-1.042-23.019l-122.469-122.47-222.014 222.015-56.654-56.654-22.517 22.517-6.435-6.435-24.377 8.512z",
    fill: "#62ddb4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.736 222.221 80.158 9.721-78.245 78.245-80.157-9.721z",
    fill: "#ff6c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.778 364.263-9.721-80.158-78.245 78.245 9.721 80.158z",
    fill: "#ff432e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.488 110.511-80.334 9.969c-120.487 38.343-164.99 169.501-171.505 189.707l26.082 26.082 130.647-108.071z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.488 110.511-9.969 80.334c-38.343 120.487-169.501 164.99-189.707 171.505l-26.082-26.082z",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m308.756 120.281c-.203.064-.4.134-.602.199l35.183 35.183 27.25-17.901 17.901-27.25c-23.64-1.257-50.98.713-79.732 9.769z",
    fill: "#ff6c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.718 190.243c-.064.203-.134.4-.199.602l-35.183-35.183 45.152-45.151c1.256 23.64-.714 50.98-9.77 79.732z",
    fill: "#ff432e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.262 186.738c-12.468-12.468-32.683-12.468-45.152 0-12.468 12.468-12.468 32.683 0 45.152l30.119-15.033z",
    fill: "#8bc7fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.262 186.738c12.468 12.468 12.468 32.683 0 45.152-12.468 12.468-32.683 12.468-45.152 0z",
    fill: "#6cb1f8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastStartIcon);
export default __webpack_public_path__ + "static/media/fast-start-icon.7bb4fe8cb8493ac3101fbbe3e0c957a7.svg";
export { ForwardRef as ReactComponent };